import css from '../../../utils/css';
import boilerplate from './boilerplate';

const contract =
  boilerplate +
  css`
    :host {
      --local-transparent-cta-color: color-mix(
        in lch,
        var(--widget-background-color) 80%,
        var(--widget-cta-background-color)
      );
      --mix-of-cta-color: color-mix(
        in lch,
        var(--widget-cta-color) 20%,
        var(--widget-cta-background-color)
      );
      --slightly-muted-text-color: color-mix(
        in lch,
        transparent 20%,
        var(--widget-text-color)
      );
      --muted-text-color: color-mix(
        in lch,
        var(--widget-text-color) 60%,
        transparent
      );
      --local-divider-color: var(--widget-divider-color, #ccc);

      --oc-text-body: var(--widget-text-color);
      --ogm-text-body: var(--widget-text-color);
      --ogm-text-main: var(--widget-text-color);
      --widget-not-supported-bet-name-text-color: var(--widget-text-color);
      --widget-header-bg-color: var(--widget-accent-background-color);
      --widget-header-text-color: var(--widget-accent-text-color);
      --widget-show-more-background-color: var(
        --widget-accent-background-color
      );

      --oc-primary-blue: var(--widget-text-color);
      --oc-text-white: white;

      --ogm-odds-grid-see-all-odds-color: var(--slightly-muted-text-color);

      --oc-text-subtext: var(--muted-text-color);
      --ogm-grid-main-bg-color: var(--widget-background-color);
      --ogm-grid-main-border-color: var(--widget-accent-background-color);
      --oc-border: var(--local-divider-color);
      --oc-line-secondary: var(--local-divider-color);

      --ogm-title-bg-color-2: var(--widget-header-bg-color);
      --ogm-title-color-1: var(--widget-header-text-color);
      --oc-bg-grey-light: var(--widget-header-odds-bg-color);
      --oc-box-shadow: var(--widget-header-odds-shadow);

      --ogm-grid-best-odds-primary-color: transparent;
      --ogm-grid-best-odds-secondary-color: var(--widget-cta-background-color);
      --ogm-grid-best-odds-text-color: var(--widget-cta-color);

      --ogm-grid-odds-tooltip-bg-color: limegreen;
      --oc-primary-white: var(--local-transparent-cta-color);

      --ogm-grid-compare-bg-color: var(--widget-accent-background-color);
      --ogm-grid-compare-color: var(--widget-accent-text-color);

      --ogm-active-tab-bg-color: var(--widget-text-color);
      --ogm-active-tab-color: var(--widget-background-color);
      --ogm-timberwolves: var(--widget-background-color);

      --ogm-grid-offer-bg-color: var(--widget-text-color);
      --ogm-grid-offer-color: var(--widget-background-color);

      --oc-odds-drifting-bg: var(
        --widget-odds-drifting-bg,
        rgba(255, 175, 186, 0.4)
      );
      --oc-odds-drifting-rgb: var(--widget-odds-drifting-rgb, 255, 175, 186);
      --oc-odds-drifting: var(--widget-odds-drifting, #ffafba);

      --oc-odds-shortening-bg: var(
        --widget-odds-shortening-bg,
        rgba(140, 204, 242, 0.4)
      );
      --oc-odds-shortening-rgb: var(
        --widget-odds-shortening-rgb,
        140,
        204,
        242
      );
      --oc-odds-shortening: var(--widget-odds-shortening, #8cccf2);

      --ogm-grid-selected-cell-bg-color: var(--widget-cta-background-color);

      /* See base.ts for why these bridge the best-odds module's cxy tokens
       * to the widget's own drift/steam/cta colours. */
      --cxy-color-surface-betting-drifting: var(--oc-odds-drifting-bg);
      --cxy-color-surface-betting-shortening: var(--oc-odds-shortening-bg);
      --cxy-color-background-interactive-base-hover: var(
        --widget-cta-background-color,
        #66f1b8
      );
      --cxy-color-text-neutral-bold: var(--oc-text-body);

      /* non-color setup */

      --ogm-font-family-1: var(--widget-font-family);
      --ogm-font-family-2: var(--widget-font-family);

      --ogm-grid-bookmaker-cell-border-radius-desktop: 2px;
      --ogm-grid-bookmaker-cell-border-radius-mobile: 2px;
      --ogm-grid-bookmaker-cell-height-desktop: 99px;
      --ogm-grid-bookmaker-cell-scale-desktop: 1.7;
      --ogm-grid-bookmaker-cell-width-desktop: var(
        --widget-grid-column-width,
        54px
      );

      --ogm-grid-cell-gap: var(--widget-grid-cell-gap, 1px);
      --ogm-grid-cell-height-desktop: 44px;
      --ogm-grid-cell-width-desktop: var(--widget-grid-cell-width, 44px);

      --ogm-grid-column-height: 54px;
      --ogm-grid-column-width: var(--widget-grid-column-width, 54px);

      --ogm-grid-market-expander-margin: 0;
      --ogm-grid-sticky-marketname-padding-bottom: 18px;

      --ogm-max-width: auto;

      /* z-indexing fix for offer tooltip */
      --cxy-z-index-above-ad: 10;

      /* consistent text colour */
      #root > *,
      [data-testid='grid-header'] {
        color: var(--widget-text-color);
      }

      /* 'show more' buttons don't inherit font-family (UA default for
       * <button>), and 'See all odds'/market heading text hardcode fonts
       * from odds-grid-external's own design system. EU-6026. */
      [class*='ShowMoreText_'] {
        color: inherit;
        font-family: var(--ogm-font-family-1);

        /* 'show more' mobile button and arrow next to it */
        [class*='MobileOnly_'] & {
          &,
          & + svg {
            color: var(--widget-accent-text-color);
          }
        }
      }
      [class*='MarketHeaderText_'] > span {
        font-family: var(--ogm-font-family-1);
      }
      [class*='SeeAllOdds_'] {
        font-family: var(--ogm-font-family-2);
      }

      /* consistent background, border */
      [class*='ExpanderContent_'] {
        background-color: var(--widget-background-color);
        border-color: var(
          --widget-accent-background-color /* enforce for not-supported state */
        ) !important;
      }
      [class*='BetContent_'] {
        background: transparent;
      }

      /* hide extraneous border under last bet on mobile view.
         Anchored on [data-testid='odds-grid-mobile'] because odds-grid-external
         12.2.1 dropped the MobileOnlyGridWrapper_ class the old selector used. */
      [data-testid='odds-grid-mobile']
        [class*='MobileOnly_']:last-child
        [class*='BetContent_']::after {
        display: none;
      }

      /* mobile best odds shape */
      [class*='EachWayTermsOddsCell_'] [class*='bestOddsStyles_'] {
        & > svg path {
          &:first-child {
            fill: var(--widget-cta-background-color);
          }
          &:not(:first-child) {
            fill: var(--widget-cta-color);
            stroke: var(--widget-cta-color);
          }
        }
      }

      [data-testid='odds-grid']:not([data-enforce-mobile])
        [class*='BookmakerCellContainer_'][class*='BookmakerCellBase_']:hover {
        --oc-text-subtext: #666;
      }

      /* make text on offers hoverables visible */
      [data-testid='signup-offer'] [class*='roundedCell_'] > span {
        z-index: 1;
        position: relative;
      }

      /* --- Buttons/Cells --- */

      /* hide BET label when hover oder grid cell */
      [class*='OddsCellDesktop_']:hover::after {
        display: none;
      }

      /* grid cell: border */
      [class*='OddsCellDesktop_'] {
        border: 1px solid currentColor !important;
      }

      /* grid cell: text colour */
      :not([class*='oddShortening_']):not([class*='oddDrifting_']):not(
          [class*='oddStable_']
        )
        > [class*='OddsCellDesktop_']:not([class*='bestOddsStyles_']) {
        color: var(--widget-text-color);
      }

      [class*='oddStable_']
        > [class*='OddsCellDesktop_']:not([class*='bestOddsStyles_']):not(
          :hover
        ) {
        color: var(--widget-text-color);
      }

      /* grid cell: best odd text colour */
      [class*='OddsCellDesktop_'][class*='bestOddsStyles_'] {
        color: var(--widget-cta-color);
      }

      /* petty temporary fix for mobile odds
       * must be looked at with/after NGF-5948
       */
      [class*='OddsCellMobile_'][class*='OddsCellBtn_'] {
        background-color: var(--local-transparent-cta-color);
        border: none;
      }

      /* common transition hover background and colour */
      [class*='OddsCellDesktop_'],
      [class*='BetBestOddsButtonWrapper'] button,
      [class*='MarketExpanderBetWrapper'] button,
      [class*='OddsCellMobile_'][class*='OddsCellBtn_'] {
        /* ensure button colour transition time matches
         * background colour transition time
         */
        transition-property: color, background, border;
        transition-duration: 200ms;

        &:hover {
          background-color: var(--widget-cta-background-color) !important;
          color: var(--widget-cta-color);
          border-color: var(--mix-of-cta-color) !important;
        }
      }

      [data-testid='odds-grid']:not(.not-supported) {
        /* market expander buttons: set default colour
         * for odds not overriding drift/steam colours
         */
        [class*='BetBestOddsButtonWrapper'] button,
        [class*='MarketExpanderBetWrapper'] button {
          &:not([class*='steamer_']):not([class*='drifter_']):not(:hover) {
            background-color: var(--local-transparent-cta-color);
          }
        }
      }

      [class*='AccordionWrapper_']
        [class*='GridToggler_'][aria-expanded='false'] {
        background: transparent;
        color: var(--widget-text-color);
      }

      /* untangle 'Compare all odds' not-supported behaviour */
      [class*='AccordionWrapper_'].not-supported [class*='GridToggler_'] {
        color: var(--widget-text-color);
        background: transparent;

        &[aria-expanded='true'] [class*='Pointer_']:before {
          background: transparent;
        }
      }

      /* not supported colour correction */
      [class*='AccordionWrapper_'].not-supported > h2 {
        background-color: var(--widget-accent-background-color);
        color: var(--widget-accent-text-color);
        border-color: var(--widget-accent-background-color);
      }

      /* bottom margin */
      [class*='GridBackground_'] {
        margin-bottom: 0 !important;
      }

      /* bottom margin */
      [class*='MarketWrapper_'] [class*='AccordionWrapper_'] [class*='ExpanderContent_'] /* amount of selector required to override already !imprtant value */ {
        margin-bottom: 0 !important;
      }
      [class*='MarketExpanderWrapper_'] {
        margin-top: 0 !important;

        /* cut off transparent 'pointer' oveflow when 'all odds' is not showing, determined by section being the last child */
        &:last-of-type {
          overflow: clip;
        }
      }
    }
  `;

export default contract;
